exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TimerBar-module__timer-background___TFzuu{display:flex}.TimerBar-module__timer-background___TFzuu .TimerBar-module__bar-container___3Sak9{width:100%;display:flex;align-items:center}.TimerBar-module__timer-background___TFzuu .TimerBar-module__bar-container___3Sak9 .TimerBar-module__progress-bar___1lW14{background-color:#ff4956;height:4px;width:100%;border-radius:4px;box-sizing:border-box}.TimerBar-module__timer-background___TFzuu p{color:#fff;margin:0 0 0 15px}", ""]);

// exports
exports.locals = {
	"timer-background": "TimerBar-module__timer-background___TFzuu",
	"bar-container": "TimerBar-module__bar-container___3Sak9",
	"progress-bar": "TimerBar-module__progress-bar___1lW14"
};